(function () {
  if (window.productCardPricing) return;

  var swatchSelector = '[data-card-product] .thumbnail-swatch .swatch';

  function selectSwatch(swatch) {
    var card = swatch.closest('[data-card-product]');
    if (!card) return;

    var variantId = swatch.getAttribute('data-variant-id');
    var state = Array.from(card.querySelectorAll('template[data-card-variant-state]')).find(function (item) {
      return item.getAttribute('data-card-variant-state') === variantId;
    });
    if (!state) return;

    var price = state.content.querySelector('[data-card-price]');
    var badge = state.content.querySelector('[data-card-badge]');
    if (!price || !badge) return;

    card.querySelectorAll('[data-card-price]').forEach(function (target) {
      target.innerHTML = price.innerHTML;
      target.querySelectorAll('.money').forEach(function (money) {
        var converter = window.PXUTheme && window.PXUTheme.currencyConverter;
        if (converter && typeof converter.update === 'function') converter.update(money);
      });
    });
    card.querySelectorAll('[data-card-badge]').forEach(function (target) {
      target.innerHTML = badge.innerHTML;
      target.hidden = badge.hidden;
    });

    card.querySelectorAll('.thumbnail-swatch .swatch').forEach(function (item) {
      var active = item === swatch;
      item.classList.toggle('active', active);
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', String(active));
    });

    card.querySelectorAll('.custom-atc [name="id"]').forEach(function (input) {
      input.value = variantId;
    });
    card.querySelectorAll('.custom-atc').forEach(function (element) {
      element.classList.add('active');
    });

    card.querySelectorAll('a[href]').forEach(function (link) {
      if (link.matches('.swatch')) return;
      var url = new URL(link.getAttribute('href'), window.location.href);
      var productPath = url.pathname.match(/\/products\/([^/]+)\/?$/);
      if (url.origin === window.location.origin && productPath && productPath[1] === card.getAttribute('data-card-product')) {
        url.searchParams.set('variant', variantId);
        link.setAttribute('href', url.pathname + url.search + url.hash);
        var linkName = swatch.getAttribute('data-card-link-name');
        if (link.matches('[data-card-image-link]') && linkName) {
          link.setAttribute('aria-label', linkName);
        }
      }
    });

    var imageUrl = swatch.getAttribute('data-variant-image');
    if (imageUrl) {
      card.querySelectorAll('.product__imageContainer img').forEach(function (image) {
        if (image.closest('.secondary')) return;
        image.setAttribute('src', imageUrl);
        image.setAttribute('srcset', imageUrl);
        if (image.hasAttribute('data-src')) image.setAttribute('data-src', imageUrl);
        if (image.hasAttribute('data-srcset')) image.setAttribute('data-srcset', imageUrl);
        var alt = swatch.getAttribute('data-variant-image-alt');
        if (alt) image.setAttribute('alt', alt);
      });
      card.classList.remove('has-secondary-image-swap');
      card.setAttribute('data-card-selected', variantId);
    }
  }

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest(swatchSelector);
    if (!swatch) return;
    event.preventDefault();
    selectSwatch(swatch);
  });

  document.addEventListener('focusin', function (event) {
    if (event.target.matches(swatchSelector)) selectSwatch(event.target);
  });

  document.addEventListener('keydown', function (event) {
    var swatch = event.target.closest(swatchSelector);
    if (!swatch) return;
    if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
      event.preventDefault();
      selectSwatch(swatch);
      return;
    }
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    event.preventDefault();
    var card = swatch.closest('[data-card-product]');
    var swatches = Array.from(card.querySelectorAll('.thumbnail-swatch .swatch'));
    var next = swatches[swatches.indexOf(swatch) + (event.key === 'ArrowRight' ? 1 : -1)];
    if (next) next.focus();
  });

  window.productCardPricing = { selectSwatch: selectSwatch };
}());
